import { render, staticRenderFns } from "./change-password.component.vue?vue&type=template&id=780eb513&"
import script from "./change-password.component.vue?vue&type=script&lang=ts&"
export * from "./change-password.component.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "change-password.component.vue"
export default component.exports